import Controller from '@ember/controller';

export default class LicenseController extends Controller {
  get license() {
    return this.model;
  }
}
